import { render } from "./BuyNFTPage.vue?vue&type=template&id=5fb3eb72&scoped=true"
import script from "./BuyNFTPage.vue?vue&type=script&lang=js"
export * from "./BuyNFTPage.vue?vue&type=script&lang=js"

import "./BuyNFTPage.vue?vue&type=style&index=0&id=5fb3eb72&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fb3eb72"]])

export default __exports__